<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-flex xs12 sm6 md1>
            <router-link to="/Dashboard">
              <v-btn icon>
                <v-icon class="white--text">close</v-icon>
              </v-btn>
            </router-link>
          </v-flex>
          <v-flex xs12 sm6 md1>
            <h2>
              ITC
            </h2>
          </v-flex>
         
          <v-flex xs12 sm6 md4>
            <v-select
              class="select-firm"
              dense
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
              clearable
            ></v-select>
          </v-flex>
          <v-spacer/>
          
          <v-flex xs12 sm3 md3>
            <v-menu
              :close-on-content-click="false"
              v-model="datepickerFrom"
              :nudge-right="40"
              class="ist-datepicker"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              clearable
            >
              <v-text-field
                slot="activator"
                v-model="fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
                clearable
              ></v-text-field>
              <v-date-picker v-model="fromDate" @input="datepickerFrom = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 md3>
            <v-menu
              :close-on-content-click="false"
              v-model="datepickerTo"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              class="ist-datepicker"
              offset-y
              full-width
              min-width="290px"
              clearable
            >
              <v-text-field
                slot="activator"
                v-model="toDate"
                label="To Date"
                prepend-icon="event"
                readonly
                clearable
              ></v-text-field>
              <v-date-picker v-model="toDate" @input="datepickerTo = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-toolbar>
        <v-layout row wrap>
          <v-flex xs12 sm6 md3>
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary" style="text-align: center;">Input GST</h3>
              </v-card-title>
              <v-card-text>
                <v-text-field label="INPUT IGST (in ₹)" :value="Number.parseFloat(inputGST.IGST)" readonly prefix></v-text-field>
                <br />
                <v-text-field label="INPUT CGST (in ₹)" :value="Number.parseFloat(inputGST.CGST)" readonly prefix></v-text-field>
                <br />
                <v-text-field label="INPUT SGST (in ₹)" :value="Number.parseFloat(inputGST.SGST)" readonly prefix></v-text-field>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md3>
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary" style="text-align: center;">Output GST</h3>
              </v-card-title>
              <v-card-text>
                <v-text-field label="OUTPUT IGST (in ₹)" :value="Number.parseFloat(outputGST.IGST)" readonly prefix></v-text-field>
                <br />
                <v-text-field label="OUTPUT CGST (in ₹)" :value="Number.parseFloat(outputGST.CGST)" readonly prefix></v-text-field>
                <br />
                <v-text-field label="OUTPUT SGST (in ₹)" :value="Number.parseFloat(outputGST.SGST)" readonly prefix></v-text-field>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md6>
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary" style="text-align: center;">RCM</h3>
                  <v-spacer></v-spacer>
                  <v-switch
                    :disabled="!selectedFirm"
                    class="paid-rtc"
                    v-model="isPaidVisible"
                    :label="`${isPaidVisible ? 'Click to View Unpaid Expenses' : 'Click to View Paid Expenses'}`"
                  ></v-switch>
              </v-card-title>
              <v-card-text>
                <v-data-table :items="expensesINV" class="elevation" :headers="expenseHeader">
                <template slot="items" slot-scope="props">
                  <td><v-btn :disabled="isPaidVisible" outlined  @click="openExpensePaymentDialog(props.item)" class="primary--text">
                  {{isPaidVisible ? 'PAID' : 'PAY' }}
                </v-btn>
                </td>
                <td>{{ props.item['expense'] }}</td>
                <td><b class="font-weight-bold">{{ getFirmName(props.item.firm) }}</b></td>
                <td>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</td>
                <td>{{ props.item.gstAmount || 0 | amount }}</td>
                <td>{{ props.item.GST_type }}</td>
                <td>{{ props.item.openingBalance || 0 | amount }}</td>
                <td><b class="error--text font-weight-bold">{{ props.item.totalAmount || 0 | amount }}</b></td>
                <!-- <td>{{ getTotalAmount(props.item)|| 0 | amount }}</td> -->
                <td>{{ ((props.item.openingBalance ?  props.item.totalAmount : 0 ) + (props.item.totalAmount ? props.item.totalAmount : 0) ) || 0| amount }}</td>
                <td>{{ props.item.paymentType }}</td>
                <td>{{ props.item.remark}}</td>
                <td>{{ props.item['.key'] }}</td>
                </template>
              <template slot="no-data">no record found</template>
            </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4>
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary" style="text-align: center;">IGST</h3>
              </v-card-title>
              <v-card-text v-bind:class="{disabledCard: e1 != 1}">
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 style="padding-right: 6px;text-align: end;">
                    <h3>Available Balance</h3>
                  </v-flex>
                  <v-flex xs12 sm3 md3 style="padding-top : 14px;">
                    <h4>Input IGST</h4>
                  </v-flex>
                  <v-flex xs12 sm9 md9 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="availableBalance.inputGST.IGST"
                      readonly
                      :disabled="e1 != 1"
                      type="number"
                    ></v-text-field>
                    <v-text-field
                      class="primary--text"
                      style="padding: 0 4px 0 4px;"
                      :value="availableBalance.inputGST.IGST"
                      readonly
                      type="number"
                      :disabled="e1 != 1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3 style="padding-top : 14px;">
                    <h4>Output IGST</h4>
                  </v-flex>
                  <v-flex xs12 sm9 md9 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      readonly
                      :value="availableBalance.outputGST.IGST"
                      :disabled="e1 != 1"
                      type="number"
                    ></v-text-field>
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      readonly
                      :value="availableBalance.outputGST.IGST"
                      :disabled="e1 != 1"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3 style="padding-top : 14px;">
                    <h4>Output CGST</h4>
                  </v-flex>
                  <v-flex xs12 sm9 md9 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :rules="settleOutputCGST"
                      :disabled="isOpDisabled() || e1 != 1"
                      v-model="settleBalance.outputGST.CGST"
                      type="number"
                    ></v-text-field>
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="availableBalance.outputGST.CGST"
                      :disabled="e1 != 1"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3 style="padding-top : 14px;">
                    <h4>Output SGST</h4>
                  </v-flex>
                  <v-flex xs12 sm9 md9 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      v-model="settleBalance.outputGST.SGST"
                      :disabled="isOpDisabled() || e1 != 1"
                      :rules="settleOutputSGST"
                      type="number"
                    ></v-text-field>
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="availableBalance.outputGST.SGST"
                      :disabled="e1 != 1"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <!-- Remaining Balance -->
                  <!-- <v-flex xs12 sm6 md6 style="padding-top : 14px;">
                    <h4>Remaining Amount</h4>
                  </v-flex>
                  <v-flex xs12 sm6 md6 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="Number.parseFloat(availableBalance.inputGST.IGST)  >= Number.parseFloat(availableBalance.outputGST.IGST)  ? (availableBalance.inputGST.IGST - availableBalance.outputGST.IGST).toFixed(2) : 0"
                      :disabled="e1 != 1"
                      :rules="settleOutputSGST"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex> -->
                </v-layout>
                <br /> 
                <!-- Payable and Receivable  -->
                <v-layout row wrap>
                  <v-flex xs12 sm6 md6> 
                    <v-text-field type="number"
                      :value="(Number.parseFloat(availableBalance.outputGST.IGST) < Number.parseFloat(availableBalance.inputGST.IGST) ? 
                      (Number.parseFloat(availableBalance.inputGST.IGST) - (Number.parseFloat(availableBalance.outputGST.IGST) + Number.parseFloat(settleBalance.outputGST.CGST) + Number.parseFloat(settleBalance.outputGST.SGST))).toFixed(2) : 0)"
                      :disabled="e1 != 1" label="Net Receiveable"  readonly prefix>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>   
                    <v-text-field type="number"
                    :disabled="e1 != 1"
                    :value="(Number.parseFloat(availableBalance.outputGST.IGST) > Number.parseFloat(availableBalance.inputGST.IGST) ? 
                    (Number.parseFloat(availableBalance.outputGST.IGST) - (Number.parseFloat(availableBalance.inputGST.IGST) + Number.parseFloat(settleBalance.outputGST.CGST) + Number.parseFloat(settleBalance.outputGST.SGST))).toFixed(2) : 0)"
                      label="Net Payable" readonly prefix>
                    </v-text-field>
                  </v-flex>
                </v-layout>  

                <!-- Buttons For Reset, Pay Now, Pay Later -->
                <v-layout row wrap>
                  <v-flex xs12 sm4 md4>
                    <v-btn small @click="reset" :disabled="e1 != 1">Reset</v-btn>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-btn small :disabled="(e1 != 1) || (Number.parseFloat(availableBalance.outputGST.IGST) < Number.parseFloat(availableBalance.inputGST.IGST))" @click="openPaymentDialog('IGST')" color="success">Pay Now</v-btn>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-btn small :disabled="e1 != 1" color="warning" @click="nextStep(1)">Pay Later</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary" style="text-align: center;">CGST</h3>
              </v-card-title>
              <v-card-text v-bind:class="{disabledCard: e1 != 2}">
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 style="padding-right: 6px;text-align: end;">
                    <h3>Available Balance</h3>
                  </v-flex>
                  <v-flex xs12 sm3 md3 style="padding-top : 14px;">
                    <h4>Input CGST</h4>
                  </v-flex>
                  <v-flex xs12 sm9 md9 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="availableBalance.inputGST.CGST"
                      readonly
                      type="number"
                      :disabled="e1 != 2"
                    ></v-text-field>
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="availableBalance.inputGST.CGST"
                      readonly
                      type="number"
                      :disabled="e1 != 2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3 style="padding-top : 14px;">
                    <h4>Output CGST</h4>
                  </v-flex>
                  <v-flex xs12 sm9 md9 style="display:inline-flex;">
                    <v-text-field style="padding: 0 4px 0 4px;" :disabled="e1 != 2" type="number"></v-text-field>
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="(availableBalance.outputGST.CGST - settleBalance.outputGST.CGST).toFixed(2)"
                      readonly
                      :disabled="e1 != 2"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3 style="padding-top : 14px;">
                    <h4>Adjusted Input IGST</h4>
                  </v-flex>
                  <v-flex xs12 sm9 md9 style="display:inline-flex;">
                    <v-text-field style="padding: 0 4px 0 4px;"
                     :value="Number.parseFloat(availableBalance.inputGST.IGST)  >= Number.parseFloat(availableBalance.outputGST.IGST)  ?
                     (Number.parseFloat(availableBalance.inputGST.IGST) - (Number.parseFloat(availableBalance.outputGST.IGST) + Number.parseFloat(settleBalance.outputGST.CGST) + Number.parseFloat(settleBalance.outputGST.SGST))).toFixed(2) : 0"
                     :disabled="e1 != 2" readonly type="number"></v-text-field>
                    <v-text-field style="padding: 0 4px 0 4px;"
                     :value="Number.parseFloat(availableBalance.inputGST.IGST)  >= Number.parseFloat(availableBalance.outputGST.IGST)  ?
                     (Number.parseFloat(availableBalance.inputGST.IGST) - (Number.parseFloat(availableBalance.outputGST.IGST) + Number.parseFloat(settleBalance.outputGST.CGST) + Number.parseFloat(settleBalance.outputGST.SGST))).toFixed(2) : 0"
                     :disabled="e1 != 2" readonly type="number"></v-text-field>
                  </v-flex>
                </v-layout>
                <br />
                <!-- Payable and Receivable Fields  -->
                <v-layout row wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field type="number"
                      :disabled="e1 != 2"
                      :value="(Number.parseFloat(availableBalance.inputGST.CGST) > (Number.parseFloat(availableBalance.outputGST.CGST) - Number.parseFloat(settleBalance.outputGST.CGST)) ? 
                      (Number.parseFloat(availableBalance.inputGST.CGST) - (Number.parseFloat(availableBalance.outputGST.CGST) - Number.parseFloat(settleBalance.outputGST.CGST))).toFixed(2) : 0)"
                      label="Net Receiveable" readonly prefix>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field type="number"
                      :value="(Number.parseFloat(availableBalance.inputGST.CGST) < (Number.parseFloat(availableBalance.outputGST.CGST) - Number.parseFloat(settleBalance.outputGST.CGST)) ? 
                      ((Number.parseFloat(availableBalance.outputGST.CGST) - Number.parseFloat(settleBalance.outputGST.CGST)) - Number.parseFloat(availableBalance.inputGST.CGST)).toFixed(2) : 0)"
                      :disabled="e1 != 2" label="Net Payable" readonly prefix>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <br />
                <!-- Buttons For Reset, Pay Now, Pay Later -->
                <v-layout row wrap>
                  <v-flex xs12 sm4>
                    <v-btn small @click="reset" :disabled="e1 != 2">Reset</v-btn>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-btn small color="success" @click="openPaymentDialog('CGST')" :disabled="(e1 != 2) || (Number.parseFloat(availableBalance.inputGST.CGST) > (Number.parseFloat(availableBalance.outputGST.CGST) - Number.parseFloat(settleBalance.outputGST.CGST)))">Pay Now</v-btn>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-btn small color="warning" :disabled="e1 != 2" @click="nextStep(2)">Pay Later</v-btn>
                  </v-flex>
                </v-layout>    
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-card flat>
              <v-card-title primary class="primary white--text">
                <h3 color="primary" style="text-align: center;">SGST</h3>
              </v-card-title>
              <v-card-text v-bind:class="{disabledCard: e1 != 3}">
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 style="padding-right: 6px;text-align: end;">
                    <h3>Available Balance</h3>
                  </v-flex>
                  <v-flex xs12 sm3 md3 style="padding-top : 14px;">
                    <h4>Input SGST</h4>
                  </v-flex>
                  <v-flex xs12 sm9 md9 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="availableBalance.inputGST.SGST"
                      readonly
                      :disabled="e1 != 3"
                      type="number"
                    ></v-text-field>
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="availableBalance.inputGST.SGST"
                      readonly
                      :disabled="e1 != 3"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm3 md3 style="padding-top : 14px;">
                    <h4>Output SGST</h4>
                  </v-flex>
                  <v-flex xs12 sm9 md9 style="display:inline-flex;">
                    <v-text-field style="padding: 0 4px 0 4px;" 
                      :disabled="e1 != 3" type="number"></v-text-field>
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="(availableBalance.outputGST.SGST - settleBalance.outputGST.SGST).toFixed(2)"
                      readonly
                      :disabled="e1 != 3"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3 md3 style="padding-top : 14px;">
                    <h4>Adjusted Input IGST</h4>
                  </v-flex>
                  <v-flex xs12 sm9 md9 style="display:inline-flex;">
                    <v-text-field style="padding: 0 4px 0 4px;" readonly
                     :value="Number.parseFloat(availableBalance.inputGST.IGST)  >= Number.parseFloat(availableBalance.outputGST.IGST)  ?
                     (Number.parseFloat(availableBalance.inputGST.IGST) - (Number.parseFloat(availableBalance.outputGST.IGST) + Number.parseFloat(settleBalance.outputGST.CGST) + Number.parseFloat(settleBalance.outputGST.SGST))).toFixed(2) : 0"
                      :disabled="e1 != 3"
                       type="number"></v-text-field>
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                        :value="Number.parseFloat(availableBalance.inputGST.IGST)  >= Number.parseFloat(availableBalance.outputGST.IGST)  ?
                     (Number.parseFloat(availableBalance.inputGST.IGST) - (Number.parseFloat(availableBalance.outputGST.IGST) + Number.parseFloat(settleBalance.outputGST.CGST) + Number.parseFloat(settleBalance.outputGST.SGST))).toFixed(2) : 0"
                      readonly
                      :disabled="e1 != 3"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <br />
                <!-- Payable and Receivable Buttons  -->
                <v-layout>
                  <v-flex xs12 md6 sm6>
                    <v-text-field type="number"
                      :disabled="e1 != 3"
                      :value="(Number.parseFloat(availableBalance.inputGST.SGST) > (Number.parseFloat(availableBalance.outputGST.SGST) - Number.parseFloat(settleBalance.outputGST.SGST)) ? 
                      (Number.parseFloat(availableBalance.inputGST.SGST) - (Number.parseFloat(availableBalance.outputGST.SGST) - Number.parseFloat(settleBalance.outputGST.SGST))).toFixed(2) : 0)"
                      label="Net Receiveable" readonly prefix>
                    </v-text-field>
                  </v-flex>  
                  <v-flex xs12 md6 sm6>
                    <v-text-field type="number"
                      :value="(Number.parseFloat(availableBalance.inputGST.SGST) < (Number.parseFloat(availableBalance.outputGST.SGST) - Number.parseFloat(settleBalance.outputGST.SGST)) ? 
                      ((Number.parseFloat(availableBalance.outputGST.SGST) - Number.parseFloat(settleBalance.outputGST.SGST)) - Number.parseFloat(availableBalance.inputGST.SGST)).toFixed(2) : 0)"
                      :disabled="e1 != 3" label="Net Payable" readonly prefix>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <br/>
                <!-- Buttons For Reset, Pay Now, Pay Later -->
                <v-layout row wrap>
                  <v-flex xs12 sm4>
                    <v-btn small @click="reset" :disabled="e1 != 3">Reset</v-btn>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-btn small :disabled="(e1 != 3 ) || (Number.parseFloat(availableBalance.inputGST.SGST) > (Number.parseFloat(availableBalance.outputGST.SGST) - Number.parseFloat(settleBalance.outputGST.SGST)))" @click="openPaymentDialog('SGST')" color="success">Pay Now</v-btn>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-btn small :disabled="e1 != 3" color="warning" @click="nextStep(3)">Pay Later</v-btn>
                  </v-flex>
                </v-layout>    
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
     <v-dialog v-model="dialog" persistent max-width="1000px">
       <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline">Payment for {{currentPaymentGSTType}}</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <h4><b class="text-error" v-if="insufficientError">Insufficient amount.</b></h4>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field type="number"
                  :value="payableAmount"
                  disabled label="Net Payable" readonly prefix>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3 >
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepicker"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="selectedDate"
                    label="Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="selectedDate" @input="datepicker = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm3 m3 >
                      <v-select
                        dense
                        :items="[{
                                  text: 'Cash',
                                  value: 'Cash'
                                }, {
                                  text: 'Bank Account',
                                  value: 'Bank Account'
                                }, {
                                  text: 'Cash & Bank Account',
                                  value: 'CashAndBank Account'
                                }]"
                        label="Select Payment Type"
                        v-model="paymentType"
                      ></v-select>
                  </v-flex>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      v-model="amountFromCash"
                      type="number"
                      label="Amount from Cash"
                      :value="payableAmount"
                      v-if="['Cash','CashAndBank Account'].includes(paymentType)"
                    ></v-text-field>
                    <b class="text-error"  v-if="['Cash','CashAndBank Account'].includes(paymentType) && !((Number.parseFloat(amountFromBank) + Number.parseFloat(amountFromCash)) == Number.parseFloat(payableAmount ))">Total should be equal to Payoff amount</b>
                    </v-flex>
                    
                    <v-flex xs12 sm3 md3>
                      <v-select
                        dense
                        :items="banksByFirms"
                        v-if="['Bank Account','CashAndBank Account'].includes(paymentType)"
                        label="Select Bank"
                        v-model="selectedBank"
                        flat
                        clearable
                        item-text="bankName"
                        return-object
                        :disabled="paymentType == 'Cash' || paymentType == ''"
                      ></v-select>
                    </v-flex>
                    
                    <v-flex xs12 sm3 md3>
                      <v-text-field
                        v-model="amountFromBank"
                        v-if="['Bank Account','CashAndBank Account'].includes(paymentType)"
                        type="number"
                        label="Amount from Bank"
                        :value="payableAmount"
                      ></v-text-field>
                      <b class="text-error"  v-if="['Bank Account','CashAndBank Account'].includes(paymentType) && !((Number.parseFloat(amountFromBank) + Number.parseFloat(amountFromCash)) == Number.parseFloat(payableAmount ))">Total should be equal to Payoff amount</b>
                    </v-flex>
                    
                    
                    <v-flex xs12 sm3 md3>
                    <v-select
                      dense
                      :disabled="paymentType == 'Cash' || paymentType == ''"
                      v-if="['Bank Account','CashAndBank Account'].includes(paymentType)"
                      :items="[{
                          text: 'Cheque',
                          value: 'Cheque'
                        }, {
                          text: 'NEFT',
                          value: 'NEFT'
                        }, {
                          text: 'RTGS',
                          value: 'RTGS'
                        }, {
                          text: 'IMPS',
                          value: 'IMPS'
                        }]"
                      label="Select Transfer type"
                      v-model="transferType"
                      @input="transferTypeDialog = true"
                    ></v-select>
                    </v-flex>
            </v-layout>
          </v-container>
          </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                @click="dialog = false"
                flat
              >Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                @click="payITC()"
                flat
              >Pay</v-btn>
        </v-card-actions>
       </v-card>
      </v-dialog>
            <v-dialog v-model="transferTypeDialog" max-width="500px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">
            Transfer Information
            <b>{{transferType}}</b>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  type="number"
                  v-model="transferDetails.accountNumber"
                  label="A/C Number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  type="text"
                  v-model="transferDetails.accountHolderName"
                  label="A/C Holder Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field type="text" v-model="transferDetails.bankName" label="Bank Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field type="text" v-model="transferDetails.IFSCcode" label="IFSC Code"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field type="text" v-model="transferDetails.remark" label="Remark"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat  @click.native="transferTypeDialog = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      selectedFirm: null,
      e1: 1,
      steps: 3,
      payMode : null,
      dialog : false,
      paymentType : '',
      selectedBank : null,
      transferType : 0,
      amountFromCash : 0,
      amountFromBank : 0,
      insufficientError : null,
      transferTypeDialog : false,
      datepicker : false,
      selectedDate : new Date().toISOString().substr(0, 10),
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      isPaidVisible : false,
      invoiceOfFirm: [],
       transferDetails: {
        accountNumber:"",
        accountHolderName: "",
        bankName: "",
        IFSCcode: "",
        remark: ""
      },
      payableAmount : 0,
      selectedInvoices : [],
      currentPaymentGSTType : '',
      inputGST: {
        IGST: 0,
        CGST: 0,
        SGST: 0
      },
      outputGST: {
        IGST: 0,
        CGST: 0,
        SGST: 0
      },
      expenseGST : {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
      },
      assetsGST : {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
      },
      availableBalance: {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        }
      },
      settleBalance: {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        }
      },
      settleOutputCGST: [
        v =>
          v < this.availableBalance.outputGST.CGST ||
          this.availableBalance.outputGST.IGST >= this.availableBalance.inputGST.IGST || "Should be less or Equal to available"
      ],
      settleOutputSGST: [
        v =>
          v < this.availableBalance.outputGST.SGST ||
          this.availableBalance.outputGST.IGST >= this.availableBalance.inputGST.IGST || "Should be less or Equal to available"
      ],
      expenseHeader: [
        { text: "Pay", value: ".key", sortable: false },
        { text: "Expense", value: ".key", sortable: false },
        { text: "Firm Name", value: "firm", sortable: true },
        { text: "Date", value: "expense", sortable: true },
        { text: "GST Amount", value: "totalAmount", sortable: false },
        { text: "GST Type", value: "totalAmount", sortable: false },
        { text: "Opening WDV", value: "openingBalance", sortable: false },
        { text: "Amount", value: "totalAmount", sortable: false },
        { text: "Closing WDV", sortable: false },
        { text: "paymentType", value: ".key", sortable: false },
        { text: "remark", value: "type", sortable: true },
        { text: "Id", value: ".key", sortable: false },
      ],
    };
  },
  created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("expenses", this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("assets", this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear","brandFinYear"]),
    firmsByBrand() {
      return this.firms
        .filter(item => item["brand"] === this.selectedBrand)
        .map(item => {
          return {
            text: item["name"],
            value: item[".key"]
          };
        });
    },
    expensesINV(){
        let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
        let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
        let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand);
        expenses = expenses.filter(expense => !!expense['.key']);
        let allInvoices = [];
        this.expenseGST = {
          inputGST: {
            IGST: 0,
            CGST: 0,
            SGST: 0
          },
          outputGST: {
            IGST: 0,
            CGST: 0,
            SGST: 0
          },
        }
        expenses.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let paymentTypeStatus = 'confirm';
          let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand 
          && invoice["expenseType"] === ex['.key'] 
          && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) 
          && invoice['isGSTApplicable'] == true
          && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true)
          && invoice["firm"] === this.selectedFirm 
          && invoice["ITC_paid"] != true
          )
          invoices.map((inv,invIndex)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            paymentTypeStatus = inv.paymentTypeStatus;
            invoices[invIndex]['expense'] = ex.expense;
            invoices[invIndex]['gstAmount'] = ((inv.taxableAmount* inv.taxableGST_rate)/100);
            if(inv['paid'] == true) {
              if(inv.GST_type == 'CGST|SGST') {
                this.expenseGST.inputGST['SGST'] += (Number.parseFloat(invoices[invIndex]['gstAmount'])/2);
                this.expenseGST.inputGST['CGST'] += (Number.parseFloat(invoices[invIndex]['gstAmount'])/2);
              } else {
                this.expenseGST.inputGST['IGST'] += Number.parseFloat(invoices[invIndex]['gstAmount']);
              }
            } else {
               if(inv.GST_type == 'CGST|SGST') {
                this.expenseGST.outputGST['SGST'] += (Number.parseFloat(invoices[invIndex]['gstAmount'])/2);
                this.expenseGST.outputGST['CGST'] += (Number.parseFloat(invoices[invIndex]['gstAmount'])/2);
              } else {
                this.expenseGST.outputGST['IGST'] += Number.parseFloat(invoices[invIndex]['gstAmount']);
              }
            }
          });
          invoices = invoices.filter((inv,invIndex)=>{ if(!this.isPaidVisible) {
            return inv['paid'] != true && inv['isRCMApplicable'] == true
          } else {
            return inv['paid'] == true && inv['isRCMApplicable'] == true
          }});
          expenses[index].paymentTypeStatus = paymentTypeStatus;
          expenses[index].totalAmount = isNaN(totalAmount) ? 0 :   Number.parseFloat(totalAmount).toFixed(2);
          expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
          allInvoices = allInvoices.concat(invoices)
        });
        //this.setData();
        this.assetsINV();
      return allInvoices;
    },
   
    banksByFirms() {
      return this.banks
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand &&
            item["firm"] === this.selectedFirm
          );
        })
    },  
  },
  methods: {
     assetsINV(){
        let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
        let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
        let assets = this.assets.filter(asset => asset.brand === this.selectedBrand);
        assets = assets.filter(asset => !!asset['.key']);
        this.assetsGST = {
          inputGST: {
            IGST: 0,
            CGST: 0,
            SGST: 0
          },
          outputGST: {
            IGST: 0,
            CGST: 0,
            SGST: 0
          },
        }
        let allIVN = [];
        //console.log(assets)
        assets.map((ast,index)=>{
          let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand 
          && invoice["assetType"] === ast['.key']
          && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) 
          && invoice['isGSTApplicable'] == true
          && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true)
          && invoice["firm"] === this.selectedFirm 
          && invoice["ITC_paid"] != true
          )
          invoices.map((inv,invIndex)=>{
            let gstAmount = (Number.parseFloat(inv.taxableAmount)* Number.parseFloat(inv.taxableGST_rate)/100);
              if(inv.GST_type == 'CGST|SGST') {
                this.assetsGST.inputGST['SGST'] += (Number.parseFloat(gstAmount)/2);
                this.assetsGST.inputGST['CGST'] += (Number.parseFloat(gstAmount)/2);
              } else {
                this.assetsGST.inputGST['IGST'] += Number.parseFloat(gstAmount);
              }
          });
          allIVN =  allIVN.concat(invoices)
        });
        this.setData()
        return allIVN;
    },
    getFirmName(e){
      let firm;
      if (this.firms && this.selectedBrand) {
        firm =this.firms.filter(item => item['.key'] === e)[0]
      }
      if(firm)
      return firm.name
    },
    payExpense(expenseInv){
       if(confirm('Are you sure you want pay?')) {
        let key  = expenseInv['.key'];
        delete expenseInv['.key'];
        expenseInv['paid'] = true;
        this.$root.$firebaseRefs.invoice.child(key).update(expenseInv, () => {
              console.info('item udpated...')
        })
      } else  {
        event.preventDefault();
      }
    },
    isOpDisabled() {
      if (
        this.availableBalance.outputGST.IGST >
        this.availableBalance.inputGST.IGST
      ) {
        this.settleBalance.outputGST.CGST = 0;
        this.settleBalance.outputGST.SGST = 0;
        return true;
      }
      return false;
    },
    payITC(){
      if(this.payMode == 'ITC') {
        let itcObject = {};
        itcObject['date'] = new Date(this.selectedDate).getTime();
        itcObject['firm'] = this.selectedFirm;
        itcObject['paidAmount'] = (Number.parseFloat(this.amountFromCash) + Number.parseFloat(this.amountFromBank));
        itcObject['gstType'] = this.currentPaymentGSTType;
        itcObject['paymentType'] = this.paymentType;
        if(['Bank Account','CashAndBank Account'].includes(this.paymentType)) {
          itcObject['bank'] = this.selectedBank['.key'];
          itcObject['transferType'] = this.transferType;
          itcObject['transferDetails'] = this.transferDetails;
        }
        itcObject['amountFromCash'] = Number.parseFloat(this.amountFromCash);
        itcObject['amountFromBank'] = Number.parseFloat(this.amountFromBank);
        itcObject['payMode'] = this.payMode
        this.$root.$firebaseRefs.itcPayment.push(itcObject);

        this.selectedInvoice.map((invoiceData)=>{
          this.updateInvoice(invoiceData);
        })
        let expenses = this.expensesINV;
        expenses.map((invoice)=>{
          invoice['ITC_paid'] = true;
          let key = invoice['.key'];
          delete invoice['.key']    
          this.$root.$firebaseRefs.invoice.child(key).update(invoice, () => {
            console.info('invoice updated...')
          })
        })

        let assets = this.assetsINV;
        assets.map((invoice)=>{
          invoice['ITC_paid'] = true;
          let key = invoice['.key'];
          delete invoice['.key']    
          this.$root.$firebaseRefs.invoice.child(key).update(invoice, () => {
            console.info('invoice updated...')
          })
        })
        this.managePayments();
        // this.selectedInvoices = [];
        // this.selectedFirm = null;
        // this.amountFromCash = 0;
        // this.amountFromBank = 0;
        // this.paymentType = null;
        // this.selectedDate = null;
        // this.transferType = null;
        // this.transferDetails =  {
        //   accountNumber:"",
        //   accountHolderName: "",
        //   bankName: "",
        //   IFSCcode: "",
        //   remark: ""
        // };
        // this.selectedBank = null;
        window.location.reload();
      } else if(this.payMode == 'RCM') {
        let itcObject = {};
        itcObject['date'] = new Date(this.selectedDate).getTime();
        itcObject['firm'] = this.selectedFirm;
        itcObject['paidAmount'] = (Number.parseFloat(this.amountFromCash) + Number.parseFloat(this.amountFromBank));
        itcObject['gstType'] = this.currentPaymentGSTType;
        itcObject['paymentType'] = this.paymentType;
        if(['Bank Account','CashAndBank Account'].includes(this.paymentType)) {
          itcObject['bank'] = this.selectedBank['.key'];
          itcObject['transferType'] = this.transferType;
          itcObject['transferDetails'] = this.transferDetails;
        }
        itcObject['amountFromCash'] = Number.parseFloat(this.amountFromCash);
        itcObject['amountFromBank'] = Number.parseFloat(this.amountFromBank);
        itcObject['payMode'] = this.payMode
        this.$root.$firebaseRefs.itcPayment.push(itcObject);
        this.payExpense(this.currentExpense);
        this.managePayments();
        window.location.reload();
      }
      this.dialog = false;
    },
     managePayments(){
       switch(this.paymentType) {
          case 'Cash' : {
            if(this.amountFromCash) {
              let firm = this.firms.filter(item => item['.key'] == this.selectedFirm)[0];
              if(firm) {
                firm.amount = (Number.parseFloat(firm.amount) - Number.parseFloat(this.amountFromCash));
                if (firm.amount < 0) {
                  this.insufficientError = 'Insufficient balance.';
                  setTimeout(() => {
                    this.insufficientError = null;
                  }, 3000);
                } else {
                  let key = firm['.key']
                  delete firm['.key']
                  this.$root.$firebaseRefs.firm.child(key).set(firm);
                  this.getInvoice();
                  this.setData();
                }
              }
            }
            break;
          }
          case 'Bank Account' : {
            if(this.amountFromBank) {
              let bank = JSON.parse(JSON.stringify(this.selectedBank));
              if(bank) {
                bank.amount =  (Number.parseFloat(bank.amount) - Number.parseFloat(this.amountFromBank)) ;  
                if (bank.amount < 0) {
                  this.insufficientError = 'Insufficient balance.';
                  setTimeout(() => {
                    this.insufficientError = null;
                  }, 3000);
                } else {
                  let key = bank['.key']
                  delete bank['.key']
                  this.$root.$firebaseRefs.account.child(key).set(bank);
                   this.getInvoice();
                  this.setData();
                }
              }
            }
            break;
          }
          case 'CashAndBank Account' : {
            if(this.amountFromCash && this.amountFromBank) {
              let bank = JSON.parse(JSON.stringify(this.selectedBank));
              if(bank) {
                bank.amount = (Number.parseFloat(bank.amount) - Number.parseFloat(this.amountFromBank)) ;  
                if (bank.amount < 0) {
                  this.insufficientError = 'Insufficient balance.';
                  setTimeout(() => {
                    this.insufficientError = null;
                  }, 3000);
                } else {
                  let key = bank['.key']
                  delete bank['.key']
                  this.$root.$firebaseRefs.account.child(key).set(bank);
                }
              }
              let firm = this.firms.filter(item => item['.key'] == this.selectedFirm)[0]
              if(firm) {
                firm.amount = (Number.parseFloat(firm.amount) - Number.parseFloat(this.amountFromCash));   
                 if (firm.amount < 0) {
                  this.insufficientError = 'Insufficient balance.';
                  setTimeout(() => {
                    this.insufficientError = null;
                  }, 3000);
                } else {
                  let key = firm['.key']
                  delete firm['.key']
                  this.$root.$firebaseRefs.firm.child(key).set(firm);
                }
              }      
            }
            this.getInvoice();
            this.setData();
            break;
          }
        }
    },
    updateInvoice (invoiceData) {
      const updated_at = new Date().getTime();
      try {
          invoiceData['items'].forEach((item, index) => {
          switch(this.currentPaymentGSTType) {
            case 'IGST' : {
              invoiceData['items'][index]['IGST_ITC_paid'] = true;
              break;
            }
            case 'CGST' : {
              invoiceData['items'][index]['CGST_ITC_paid'] = true;
              break;
            }
            case 'SGST' : {
              invoiceData['items'][index]['SGST_ITC_paid'] = true;
              break;
            }
          }
        })
        invoiceData['updated_at'] = updated_at;
        let key = invoiceData['.key'];
        delete invoiceData['.key']    
        this.$root.$firebaseRefs.invoice.child(key).update(invoiceData, () => {
          console.info('invoice updated...')
        })
      } catch(e) {
        console.info('Error at update Invoice', e)
      }
    },
    openPaymentDialog(type){
      this.dialog = true;
      this.currentPaymentGSTType = type;
      this.payMode='ITC';
      switch(type) {
        case 'IGST' : {
          this.payableAmount = (Number.parseFloat(this.availableBalance.outputGST.IGST) > Number.parseFloat(this.availableBalance.inputGST.IGST) ? 
                    (Number.parseFloat(this.availableBalance.outputGST.IGST) - (Number.parseFloat(this.availableBalance.inputGST.IGST) + Number.parseFloat(this.settleBalance.outputGST.CGST) + Number.parseFloat(this.settleBalance.outputGST.SGST))).toFixed(2) : 0);
          break;
        }
        case 'CGST' : {
          this.payableAmount = (Number.parseFloat(this.availableBalance.inputGST.CGST) < (Number.parseFloat(this.availableBalance.outputGST.CGST) - Number.parseFloat(this.settleBalance.outputGST.CGST)) ? 
                      ((Number.parseFloat(this.availableBalance.outputGST.CGST) - Number.parseFloat(this.settleBalance.outputGST.CGST)) - Number.parseFloat(this.availableBalance.inputGST.CGST)).toFixed(2) : 0);
          break;
        }
        case 'SGST' : {
          this.payableAmount = (Number.parseFloat(this.availableBalance.inputGST.SGST) < (Number.parseFloat(this.availableBalance.outputGST.SGST) - Number.parseFloat(this.settleBalance.outputGST.SGST)) ? 
                      ((Number.parseFloat(this.availableBalance.outputGST.SGST) - Number.parseFloat(this.settleBalance.outputGST.SGST)) - Number.parseFloat(this.availableBalance.inputGST.SGST)).toFixed(2) : 0);
          break;
        }
      }
    },
    openExpensePaymentDialog(expenseInv){
      this.dialog = true;
      this.payMode='RCM';
      this.currentPaymentGSTType = expenseInv.GST_type;
      this.payableAmount = expenseInv.gstAmount;
      this.currentExpense = expenseInv;
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    },
    getInvoice() {
      this.invoiceOfFirm = this.invoices.filter(item => {
        return (
          item["brand"] === this.selectedBrand &&
          item["firm"] === this.selectedFirm &&
          (item.date >= this.finYear.start) && (item.date <= this.finYear.end) && 
          (item.deleted != true) &&
          item['items'] &&
          item['items'].length
        );
      });
      this.setData();
    },
    resetGSTVals() {
      this.inputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      this.outputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      (this.availableBalance = {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        }
      }),
        (this.settleBalance = {
          inputGST: {
            IGST: 0,
            CGST: 0,
            SGST: 0
          },
          outputGST: {
            IGST: 0,
            CGST: 0,
            SGST: 0
          }
        });
    },
    setData() {
      // if(!this.invoiceOfFirm.length && this.selectedFirm) {
      //   this.getInvoice();
      // }
      this.selectedInvoice = [];
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      this.resetGSTVals();
      this.invoiceOfFirm.map(invoice => {
        if (!invoice.return && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true)) {
          this.selectedInvoice.push(invoice);
          if (invoice.isBuyer) {
            invoice.items.map(item => {
              this.outputGST.SGST += (item.SGST_val && !item.SGST_ITC_paid)
                ? Number.parseFloat(item.SGST_val)
                : 0;
              this.outputGST.CGST += (item.CGST_val && !item.CGST_ITC_paid)
                ? Number.parseFloat(item.CGST_val)
                : 0;
              this.outputGST.IGST += (item.IGST_val && !item.IGST_ITC_paid)
                ? Number.parseFloat(item.IGST_val)
                : 0;
            });
          } else {
            invoice.items.map(item => {
              this.inputGST.SGST += (item.SGST_val && !item.SGST_ITC_paid)
                ? Number.parseFloat(item.SGST_val)
                : 0;
              this.inputGST.CGST += (item.CGST_val && !item.CGST_ITC_paid)
                ? Number.parseFloat(item.CGST_val)
                : 0;
              this.inputGST.IGST += (item.IGST_val && !item.IGST_ITC_paid)
                ? Number.parseFloat(item.IGST_val)
                : 0;
            });
          }
        }
      });

     

      this.inputGST.SGST += Number.parseFloat(this.expenseGST.inputGST.SGST);
      this.inputGST.CGST += Number.parseFloat(this.expenseGST.inputGST.CGST);
      this.inputGST.IGST += Number.parseFloat(this.expenseGST.inputGST.IGST);

      this.inputGST.SGST += Number.parseFloat(this.assetsGST.inputGST.SGST);
      this.inputGST.CGST += Number.parseFloat(this.assetsGST.inputGST.CGST);
      this.inputGST.IGST += Number.parseFloat(this.assetsGST.inputGST.IGST);

      this.outputGST.SGST += Number.parseFloat(this.expenseGST.outputGST.SGST);
      this.outputGST.CGST += Number.parseFloat(this.expenseGST.outputGST.CGST);
      this.outputGST.IGST += Number.parseFloat(this.expenseGST.outputGST.IGST);

      // this.$set(this.inputGST, 'SGST', this.inputGST.SGST.toFixed(2));
      // this.$set(this.inputGST, 'CGST', this.inputGST.CGST.toFixed(2));
      // this.$set(this.inputGST, 'IGST', this.inputGST.IGST.toFixed(2));

      // this.$set(this.outputGST, 'SGST', this.outputGST.SGST.toFixed(2));
      // this.$set(this.outputGST, 'CGST', this.outputGST.CGST.toFixed(2));
      // this.$set(this.outputGST, 'IGST', this.outputGST.IGST.toFixed(2));

      // this.$set(this.availableBalance, 'inputGST', this.inputGST);
      // this.$set(this.availableBalance, 'outputGST', this.outputGST);

      this.inputGST.SGST = this.inputGST.SGST.toFixed(2);
      this.inputGST.CGST = this.inputGST.CGST.toFixed(2);
      this.inputGST.IGST = this.inputGST.IGST.toFixed(2);

      this.outputGST.SGST = this.outputGST.SGST.toFixed(2);
      this.outputGST.CGST = this.outputGST.CGST.toFixed(2);
      this.outputGST.IGST = this.outputGST.IGST.toFixed(2);

      this.availableBalance.inputGST = this.inputGST;
      this.availableBalance.outputGST = this.outputGST;
    },
    reset() {
      this.settleBalance.outputGST.CGST = 0;
      this.settleBalance.outputGST.SGST = 0;
      this.e1 = 1;
    }
  },
  watch: {
    selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        this.setData();
      }
    },
    toDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        this.setData();
      }
    },
    fromDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        this.setData();
      }
    }
  }
};
</script>

<style >
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}

.disabledCard {
  background: lightgray;
}

.ist-datepicker .v-icon,.ist-datepicker .v-label, .ist-datepicker input{
  color: white !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
}

.paid-rtc .theme--light.v-label {
    color: white;
}

.paid-rtc .v-input--switch__track {
    color: rgba(255, 255, 255, 0.38);
}

.paid-rtc .v-input__slot {
  margin-bottom: 0px !important;
}

.paid-rtc.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/IST/index.vue